import React, { useMemo } from 'react'

import { useLocalization } from '../../../app/_providers/LocalizationProvider.client'
import { usePortal } from '../../../app/_providers/PortalProvider.client'
import { useFixturesContext } from '../../../brunswick/containers/fixtures'
import { PromoBar as Props } from '../../../types/graphql'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const PromoBar: React.FC<Props> = props => {
  const viewModel = useViewModel(props)
  return <Template {...viewModel} />
}

export const PromoBarFromContext: React.FC = () => {
  const { promoBar: defaultPromoBar, regionData } = useFixturesContext()
  const { region: currentRegion } = useLocalization()
  const { portal } = usePortal()

  const regionalPromoBar = useMemo(() => {
    return regionData?.regions.find(contentfulRegion => contentfulRegion.id === currentRegion.id)
      ?.promoBarRegion
  }, [currentRegion.id, regionData?.regions])

  const promoBar = regionalPromoBar ?? defaultPromoBar

  if (!promoBar) return null

  return (
    <PromoBar
      {...promoBar}
      pages={
        portal?.promoBarPages && portal.promoBarPages.length > 0
          ? portal.promoBarPages
          : promoBar.pages
      }
    />
  )
}
